/**
 * Localization messages for useIgnoreBanner hook
 */
const invertedMessages = {
  'The rule recommendation was successfully ignored.':
    'ruleRecs.banner.ruleIgnoreSuccess',
  'The rule could not be ignored due to an internal error.':
    'ruleRecs.banner.ruleIgnoreError',
} as const;

export default invertedMessages;
